module.exports = __webpack_public_path__ + "img/christmas-compassion.68d49e31.png";